// extracted by mini-css-extract-plugin
export default {"container":"fTpKpneuxgk60r0bKXEo","linksContainer":"dJTxqTV34xlGfY_ZGK81","boldLink":"JPWiWCTdkr2sDcCoZlF4"};